/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform User API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Pagination,
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    UserResponse,
    UserResponseFromJSON,
    UserResponseFromJSONTyped,
    UserResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaginatedUserListResponse
 */
export interface PaginatedUserListResponse {
    /**
     * 
     * @type {Pagination}
     * @memberof PaginatedUserListResponse
     */
    pagination: Pagination;
    /**
     * 
     * @type {Array<UserResponse>}
     * @memberof PaginatedUserListResponse
     */
    data?: Array<UserResponse>;
}

export function PaginatedUserListResponseFromJSON(json: any): PaginatedUserListResponse {
    return PaginatedUserListResponseFromJSONTyped(json, false);
}

export function PaginatedUserListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedUserListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pagination': PaginationFromJSON(json['pagination']),
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserResponseFromJSON)),
    };
}

export function PaginatedUserListResponseToJSON(value?: PaginatedUserListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pagination': PaginationToJSON(value.pagination),
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserResponseToJSON)),
    };
}


